import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = (props) => {

    const { pathname } = useLocation(null);

    useEffect(() => {

        if (
            !(/\/(.*)\/bidding\/(.*)\/contract\/(.*)/gm.test(pathname)) &&
            !pathname?.includes('shortlist') &&
            !(/\/(.*)\/bidding\/(.*)\/talent\-pool\/(.*)/gm.test(pathname)) &&
            !(/\/(.*)\/browse\/(.*)/gm.test(pathname)) &&
            !(/\/(.*)\/add-talent\/(.*)/gm.test(pathname))
        )
        {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }

    }, [pathname]);

    return null;
}

export default ScrollToTop;